/**
 * C 端参会用户凭证（与 B 端 token/user 完全隔离）
 */

const TOKEN_KEY = 'participant_token'
const PARTICIPANT_KEY = 'participant'

/** 读取 C 端 Token */
export function getParticipantToken () {
  return localStorage.getItem(TOKEN_KEY) || ''
}

/** 是否已登录 C 端 */
export function isParticipantLoggedIn () {
  return Boolean(getParticipantToken())
}

/** 读取参会用户对象 */
export function getParticipant () {
  try {
    const raw = localStorage.getItem(PARTICIPANT_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

/** 参会用户 id */
export function getParticipantId () {
  const p = getParticipant()
  return p?.id ?? null
}

/**
 * 写入登录成功响应
 * @param {{ token: string, participant: object }} res
 */
export function setParticipantAuth (res) {
  if (res?.token) {
    localStorage.setItem(TOKEN_KEY, res.token)
  }
  if (res?.participant) {
    localStorage.setItem(PARTICIPANT_KEY, JSON.stringify(res.participant))
  }
}

/** 更新本地 participant 缓存 */
export function updateParticipantCache (participant) {
  if (participant) {
    localStorage.setItem(PARTICIPANT_KEY, JSON.stringify(participant))
  }
}

/** 清除 C 端登录态 */
export function clearParticipantAuth () {
  localStorage.removeItem(TOKEN_KEY)
  localStorage.removeItem(PARTICIPANT_KEY)
}
